export enum ElectronicSignatureStep {
  GetInfoPatient,
  GenerateLink,
  SendToPatient,
}
